import React from 'react';

const Footer = () => (
  <footer className="site-footer">
    <p>
      Avigya Paudel &middot;{' '}
      <a href="mailto:paudela@union.edu">paudela@union.edu</a> &middot;{' '}
      <a href="https://github.com/Avi161" target="_blank" rel="noopener noreferrer">GitHub</a> &middot;{' '}
      <a href="https://www.linkedin.com/in/avigya-paudel-531119306/" target="_blank" rel="noopener noreferrer">LinkedIn</a> &middot;{' '}
      <a href="https://scholar.google.com/citations?user=D0SkxC0AAAAJ&hl=en" target="_blank" rel="noopener noreferrer">Google Scholar</a>
    </p>
  </footer>
);

export default Footer;
